// import TrocarSenha from './Index.vue'
import Permissions from "../../models/Permissions";

const TrocarSenha = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

export default [
  {
    path: "/trocarSenha",
    name: "TrocarSenha",
    component: TrocarSenha,
    meta: {
      requiresAuth: true,
      requiresCompany: false,
      showInMenu: true,
      label: "Trocar Senha",
      icon: "fa fa-key",
      group: "Configurações",
      permissions,
    },
  },
];
